import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { handleGet, handleSend } from "../../../controllers/controller.all";
import Loader from "../../template/view.loader";
import { confirmAlert } from "../../../components/ui/confirmAlert";

export default function DeletionRequestList() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const user = useSelector((state) => state.userReducer?.user);
    const ecoleId = user?.ecole?._id || user?.ecole;
    const token = useSelector((state) => state.userReducer?.token);

    const fetchRequests = useCallback(() => {
        if (ecoleId) {
            handleGet(`/deletion-request/ecole/${ecoleId}`, setRequests, token);
        }
    }, [ecoleId, token]);

    useEffect(() => {
        fetchRequests();
    }, [fetchRequests]);

    const handleValidate = async (id, userName) => {
        const isConfirmed = await confirmAlert({
            title: "Validation de suppression",
            message: `Voulez-vous vraiment VALIDER la suppression du compte de ${userName} ? Cette action est IRRÉVERSIBLE et supprimera toutes ses données.`,
            confirmText: "Valider la suppression",
            type: "danger"
        });

        if (isConfirmed) {
            const res = await handleSend(null, `/deletion-request/validate/${id}`, {}, setLoading, token);
            if (res && res.state === "success") {
                fetchRequests();
            }
        }
    };

    const handleReject = async (id, userName) => {
        const reason = window.prompt(`Indiquez le motif du rejet de la demande de suppression de compte pour ${userName} :`);
        if (reason !== null) {
            const res = await handleSend(null, `/deletion-request/reject/${id}`, { reason }, setLoading, token);
            if (res && res.state === "success") {
                fetchRequests();
            }
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="flex flex-col w-full h-full p-4 overflow-y-auto">
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-600 mb-6">Demandes de suppression de compte</h1>

            <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-200">
                            <th className="p-4 border-b dark:border-gray-600">Élève</th>
                            <th className="p-4 border-b dark:border-gray-600">Motif</th>
                            <th className="p-4 border-b dark:border-gray-600">Date de demande</th>
                            <th className="p-4 border-b dark:border-gray-600">Contacts Tuteurs</th>
                            <th className="p-4 border-b dark:border-gray-600 text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requests.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="p-4 text-center text-gray-500">Aucune demande en attente.</td>
                            </tr>
                        ) : (
                            requests.map((req) => (
                                <tr key={req._id} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition">
                                    <td className="p-4 border-b dark:border-gray-600 text-gray-800 dark:text-gray-400">
                                        {req.user ? `${req.user.nom} ${req.user.prenom}` : 'Utilisateur introuvable'}
                                    </td>
                                    <td className="p-4 border-b dark:border-gray-600 text-gray-800 dark:text-gray-400">
                                        {req.reason || <span className="italic text-gray-400">Non renseigné</span>}
                                    </td>
                                    <td className="p-4 border-b dark:border-gray-600 text-gray-800 dark:text-gray-400">
                                        {req.created_at}
                                    </td>
                                    <td className="p-4 border-b dark:border-gray-600 text-gray-800 dark:text-gray-400">
                                        {req.user?.tuteurs?.length > 0 ? (
                                            <ul className="list-disc pl-4">
                                                {req.user.tuteurs.map((t, idx) => (
                                                    <li key={idx}>{t.nom} - {t.tel}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <span className="text-red-500 text-sm">Aucun tuteur enregistré</span>
                                        )}
                                    </td>
                                    <td className="p-4 border-b dark:border-gray-600 text-center">
                                        <div className="flex items-center justify-center gap-2">
                                            <button 
                                                onClick={() => handleValidate(req._id, req.user ? `${req.user.nom} ${req.user.prenom}` : 'Inconnu')}
                                                className="bg-red-500 hover:bg-red-600 text-white font-medium py-1.5 px-3 rounded shadow transition text-sm"
                                            >
                                                Valider
                                            </button>
                                            <button 
                                                onClick={() => handleReject(req._id, req.user ? `${req.user.nom} ${req.user.prenom}` : 'Inconnu')}
                                                className="bg-gray-500 hover:bg-gray-600 text-white font-medium py-1.5 px-3 rounded shadow transition text-sm"
                                            >
                                                Rejeter
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
